import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterInformeCasino from 'views/reports/informeCasino/filterInformeCasino'; // Importing filter component for Informe Casino
import TableInformeCasino from 'views/reports/informeCasino/tableInformeCasino'; // Importing table component for Informe Casino
import DetailsInformeCasino from 'views/reports/informeCasino/detailsInformeCasino'; // Importing details component for Informe Casino
import RecordInformeCasino from 'views/reports/informeCasino/recordInformeCasino'; // Importing record component for Informe Casino
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the Informe Casino view.
 * @extends JetView
 */
export default class InformeCasinoView extends JetView {
    /**
     * Configures the layout of the Informe Casino view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Right section containing players view and details
        const right = {
            type: 'wide',
            rows: [PlayersView, DetailsInformeCasino, RecordInformeCasino],
        };

        // Toolbar configuration for pagination
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: 15, // Number of items per page
                },
            ],
        };

        // Left section containing filters and table
        const left = {
            Width: 250,
            responsiveCell: false,
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Applying the current theme
                    elements: [
                        {
                            view: 'label', // Label for the Informe Casino title
                            label: _('Informe Casino'), // Localized title
                            width: 150,
                        },
                    ],
                },
                FilterInformeCasino, // Filter component
                TableInformeCasino, // Table component
                toolbar, // Pagination toolbar
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Returning the main layout configuration
        return {
            type: 'wide',
            responsive: true,
            css: 'out', // CSS class for styling
            cols: [left, { view: 'resizer' }, right], // Main layout structure
        };
    }
}

// FILE DOCUMENTED
